<!-- <hello name="{{ name }}"></hello> -->
<p>
    Place your website url to load into Angular
  </p>
  {{name}}
  <div [innerHtml]="KisshtHtml"></div>